<template>
  <main class="promo-main video-main">
    <header class="promo-toolbar">
      <div class="toolbar-left">
        <span class="title">视频结果</span>
      </div>
      <div class="toolbar-actions">
        <button class="ghost-btn" @click="workbench.videoPlaying = false">停止播放</button>
      </div>
    </header>

    <section class="promo-gallery">
      <div class="gallery-grid">
        <div v-if="workbench.videoGen.loading" class="gallery-card loading">
          <div class="pulse-bg"></div>
          <div class="card-center">
            <div class="ring">
              <svg class="ring-svg" viewBox="0 0 100 100">
                <circle class="ring-track" cx="50" cy="50" r="40"></circle>
                <circle
                  class="ring-stroke"
                  cx="50"
                  cy="50"
                  r="40"
                  :style="{ strokeDashoffset: 251.2 * (1 - (workbench.videoProgress || 0) / 100) }"
                ></circle>
              </svg>
              <div class="ring-text">{{ Math.round(workbench.videoProgress || 0) }}%</div>
            </div>
            <p class="load-text">视频生成中...</p>
          </div>
        </div>

        <div v-else-if="workbench.videoGen.url" class="gallery-card result">
          <template v-if="workbench.videoPlaying">
            <video
              ref="videoPlayer"
              :src="workbench.videoGen.url"
              class="card-video"
              controls
              playsinline
              autoplay
            ></video>
          </template>
          <template v-else>
            <img :src="workbench.videoCover || workbench.videoGen.url" class="card-img" alt="video cover" />
          </template>

          <div class="overlay"></div>
          <div class="card-actions">
            <button class="action-btn glass" title="预览播放" @click.stop="onStartPreview">
              <svg class="icon-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                ></path>
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                ></path>
              </svg>
            </button>
            <button class="action-btn blue" title="下载视频" @click.stop="workbench.downloadVideo">
              <svg class="icon-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                ></path>
              </svg>
            </button>
          </div>
          <div class="card-label">Video</div>
        </div>

        <div v-else-if="workbench.selectedVideoImage" class="gallery-card result">
          <img :src="workbench.selectedVideoImage" class="card-img" alt="selected" />
          <div class="overlay"></div>
          <div class="card-label">待生成</div>
        </div>

        <div v-else class="gallery-card is-empty">
          <div class="empty-card">
            <div class="icon-box">
              <svg class="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke-width="2"></rect>
                <polyline
                  points="10 8 16 12 10 16 10 8"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></polyline>
              </svg>
            </div>
            <span class="label-main">等待生成</span>
            <span class="label-sub">选择宣传图后生成视频</span>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup>
import { ref } from 'vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'

const workbench = useWorkbenchStore()
const videoPlayer = ref(null)

const onStartPreview = () => {
  workbench.startVideoPreview(videoPlayer.value)
}
</script>
